import type { CSSProperties } from 'react';

import cn from 'classnames';

import { CommentButton } from '@/ui/CommentButton';
import { LikeButton } from '@/ui/LikeButton';

import * as styles from './PostCardActions.css';
import type { PostCardActionsElementProps } from './PostCardActions.types';

export function PostCardActionsElement(props: PostCardActionsElementProps) {
  const { element, children, attributes, isLive, onLikeClick, onCommentClick, postId, postSlug } = props;

  const {
    data,
    gap,
    width,
    maxWidth,
    flexDirection,
    mobileFlexDirection,
    buttonFontSize,
    buttonPadding,
    buttonColor,
    buttonBackgroundColor,
    hoverButtonColor,
    hoverButtonBackgroundColor,
  } = element.attrs;

  return (
    <>
      <div
        className={cn('w-full flex items-center relative', !isLive && 'pointer-events-none', styles.container)}
        style={
          {
            width,
            maxWidth,
            gap,
            '--flex-direction': flexDirection,
            '--mobile-flex-direction': mobileFlexDirection,
            '--button-font-size': buttonFontSize,
            '--button-padding': buttonPadding,
            '--button-color': buttonColor,
            '--button-background-color': buttonBackgroundColor,
            '--hover-button-color': hoverButtonColor,
            '--hover-button-background-color': hoverButtonBackgroundColor,
          } as CSSProperties
        }
        {...attributes}
      >
        {/* Like Button */}
        <LikeButton
          data={{
            isLiked: data?.isLiked || false,
            likesCount: !data?.likes || data.likes === 0 ? undefined : data.likes,
          }}
          buttonType="button"
          styles={styles}
          iconSize={Number.parseInt(buttonFontSize as string)}
          onClick={(e) => {
            if (postId) {
              e.preventDefault();
              e.stopPropagation();
              onLikeClick?.(postId);
            }
          }}
        />

        {/* Comment Button */}
        <CommentButton
          data={{
            commentsCount: !data?.comments || data.comments === 0 ? undefined : data.comments,
          }}
          styles={styles}
          iconSize={Number.parseInt(buttonFontSize as string)}
          onClick={(e) => {
            if (postSlug) {
              e.preventDefault();
              e.stopPropagation();
              onCommentClick?.(postSlug);
            }
          }}
        />
      </div>

      {children}
    </>
  );
}
